export const GROUP_NAME = 'slider'

export enum Orientations {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

export const DEFAULT_ORIENTATION = Orientations.Horizontal
